import { render, staticRenderFns } from "./ReportSidebar.vue?vue&type=template&id=6c5aada1&scoped=true"
import script from "./ReportSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportSidebar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5aada1",
  null
  
)

export default component.exports